package com.macrofocus.trenddisplay.timeseriesplot

import com.macrofocus.common.properties.AbstractMutableProperty
import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.common.properties.PropertyEvent
import com.macrofocus.common.properties.PropertyListener
import com.macrofocus.high_d.axis.AxisModel
import com.macrofocus.high_d.axis.group.AxisGroupModel

class AxisModelProperty<Row, Column>(private val root: AxisGroupModel<Row, Column>, column: MutableProperty<Column?>) :
    AbstractMutableProperty<AxisModel<Row, Column>?>() {
    private val column: MutableProperty<Column?>

    init {
        this.column = column

        column.addPropertyListener(object : PropertyListener<Column?> {
            override fun propertyChanged(event: PropertyEvent<Column?>) {
                val oldValue = getAxisModel(event.oldValue)
                val newValue = getAxisModel(event.newValue)

                notifyPropertyChanged(PropertyEvent<AxisModel<Row,Column>?>(oldValue, newValue))
            }
        })
    }

    override var value: AxisModel<Row, Column>?
        get() = getAxisModel(column.value)
        set(axisModel) {
            column.value = axisModel?.column
        }

    fun getAxisModel(column: Column?): AxisModel<Row, Column>? {
        return if (column != null) {
            root.getAxisModel(column as String)
        } else {
            null
        }
    }
}